'use strict';

/* Import CSS Plugins and main SCSS */
import 'normalize.css/normalize.css';
import '../css/main.scss';

/* Import custom JS */
import { UTILS } from './utils/utils';
import { HANDLES } from './commons/handles';
import { FIGURES } from './figures/figures';

window.h5 = {
    init: () => {
        FIGURES.init();
        UTILS.init();
        HANDLES.init();
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.h5.init());
} else {
    window.h5.init();
}
